module.exports = __webpack_public_path__ + "img/element-icons-120-x-76-ic-rank-13@3x.3ef03ab7.png";